/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Trigger: specific classes
		 */
		// none yet

		/**
		 * Swiper: js-swiper-fullwidth
		 */
		var swiper = new Swiper('.js-swiper-fullwidth', {
			 // navigation: {
			// 	nextEl:'.js-next',
			// 	prevEl:'.js-prev'
			 // },
			loop:true,
		
  			
  			spaceBetween: 40,
			
			autoplay: {
				delay: 2000,
		  	},

			breakpoints: {
			    // when window width is >= 320px
			    100: {
			      slidesPerView: 3,
			      spaceBetween: 20
			    },
			    // when window width is >= 480px
			    480: {
			      slidesPerView: 3,
			      spaceBetween: 20
			    },
			    // when window width is >= 640px
			    640: {
			     slidesPerView: 5,
			      spaceBetween: 40
				}

			},

			on: {
	          init: function () {
	            $('.js-swiper-fullwidth').css({'opacity':1});
	          }
	        }
		});
		
		/**
		 * Snowfall
		*/
		if ($('.js-skiareas').length) {
			$('.js-skiareas').snowfall({
				round: 0,
				minSize: 5,
				maxSize: 8,
				image: "https://static.vecteezy.com/system/resources/previews/052/856/367/large_2x/white-snowflake-on-transparent-background-free-png.png",
				flakeCount: 20
			});
		}
		if ($('.js-go-snow').length) {
			$('.js-go-snow').snowfall({
				round: 0,
				minSize: 5,
				maxSize: 8,
				image: "https://static.vecteezy.com/system/resources/previews/052/856/367/large_2x/white-snowflake-on-transparent-background-free-png.png",
				flakeCount: 20
			});
		}

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init);

